import { render, staticRenderFns } from "./movement-display.vue?vue&type=template&id=7669d8be&scoped=true"
import script from "./movement-display.vue?vue&type=script&lang=ts&setup=true"
export * from "./movement-display.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./movement-display.vue?vue&type=style&index=0&id=7669d8be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7669d8be",
  null
  
)

export default component.exports